import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface InfoBannerToggleProps {
  isExpanded: boolean;
}

const InfoBannerToggleRoot = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  color: "#5E7782",
  padding: "4px",
  flexShrink: 0,
});

const InfoBannerToggleLabel = styled(Typography)({
  fontSize: "0.78571rem",  // 11px
  fontWeight: 600,
  letterSpacing: "0.3px",
  color: "inherit",
  userSelect: "none",
  textTransform: "uppercase"
});

/**
 * Presentational toggle indicator for the InfoBanner header.
 * aria-hidden because the parent ButtonBase already communicates
 * the expanded state via aria-expanded.
 */
const InfoBannerToggle = ({ isExpanded }: InfoBannerToggleProps) => {
  return (
    <InfoBannerToggleRoot aria-hidden="true">
      <InfoBannerToggleLabel>
        {isExpanded ? "Hide" : "Show"}
      </InfoBannerToggleLabel>
      <ExpandMoreIcon
        sx={{
          fontSize: "1.2857rem",   // 18px
          color: "inherit",
          transition: "transform 0.2s",
          transform: isExpanded ? "rotate(0deg)" : "rotate(180deg)",
        }}
      />
    </InfoBannerToggleRoot>
  );
};

export default InfoBannerToggle;

